<template>
  <v-app id="inspire">
    <v-app-bar
        app
        clipped-right
        color="primary"
        dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>{{ $t('layout.appBar.title') }}</v-toolbar-title>
      <v-spacer></v-spacer>

      <div class="white--text mr-5" v-if="this.$store.getters.appLogin">{{ $t('layout.appBar.identifier') }}: {{ this.$store.getters.appLogin.id}}</div>
      <div class="white--text mr-5" v-if="this.$store.getters.appLogin && this.$store.getters.appLogin.inn">{{ this.$store.getters.appLogin.name}} : {{ this.$store.getters.appLogin.organization.inn}}</div>
     <div
  class="white--text mr-5"
  v-if="$store.getters.appLogin && $store.getters.appLogin._globalorganization"
>
  {{ $store.getters.appLogin._name }} : {{ $store.getters.appLogin._globalorganization._inn }}
</div>

      <div v-if="$store.getters.appLogin && $store.getters.appLogin.id === 4" class="d-flex align-center mr-5">
        <v-text-field
            ref="searchInput"
            v-model="contractText"
            :label="$t('layout.appBar.contractLabel')"
            outlined
            dense
            class="smaller-text-field"
            style="height: 10px; margin-top:-25px;"
        ></v-text-field>
        <v-btn
            small
            color="white"
            class="ml-2 black--text same-height"
            @click="updateContractText"
        >
          {{ $t('layout.appBar.saveBtn') }}
        </v-btn>
      </div>

      <div class="white--text mr-5" v-else>
        {{ contractText }}
      </div>


      <LanguageSwitcher />
      <v-btn small color="primary_button" class="black--text" @click="onLogoutClicked">{{ $t('layout.appBar.logoutBtn') }}</v-btn>
    </v-app-bar>

    <v-navigation-drawer
        v-model="drawer"
        app
    >
      <v-list dense>
        <!--<v-list-item @click.stop="left = !left">
            <v-list-item-action>
                <v-icon>mdi-exit-to-app</v-icon>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title>Open Temporary Drawer</v-list-item-title>
            </v-list-item-content>
        </v-list-item>-->
        
        <v-list-item :to="{name: 'dashboard'}">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('layout.navDrawer.home') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider inset></v-divider>

        <v-list-item :to="{name: 'mail-create-pdf-form'}" v-if="isDefault">
          <v-list-item-action>
            <v-icon>mdi-email-plus</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('layout.navDrawer.createFromPdf') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{name: 'mail-create-excel-registry'}" v-if="$store.getters.hasAccessToImportFromRegistry && $store.getters.appLogin && $store.getters.appLogin.organization">
          <v-list-item-action>
            <v-icon>mdi-file-excel</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('layout.navDrawer.createFromRegistry') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider inset></v-divider>

        <v-list-item :to="{name: 'mails-listing-draft'}" v-if="isDefault">
          <v-list-item-action>
            <v-icon>mdi-email-open</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('layout.navDrawer.created') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{name: 'mails-listing-sent'}" v-if="isDefault">
          <v-list-item-action>
            <v-icon>mdi-email-send</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('layout.navDrawer.sent') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{name: 'mails-listing-all'}" v-if="isDefault">
          <v-list-item-action>
            <v-icon>mdi-email</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('layout.navDrawer.all') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider inset></v-divider>

        <v-list-item :to="{name: 'user-unit-statistics-page'}" v-if="hasPermissionToSeeUnitStatistics">
          <v-list-item-action>
            <v-icon>mdi-file-tree-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('layout.navDrawer.myDepartments') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{name: 'track', params: {uid: ' '}}">
          <v-list-item-action>
            <v-icon>mdi-file-eye-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('layout.navDrawer.letterProtocol') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <template v-if="isAdmin">
          <v-divider inset></v-divider>

          <v-list-item :to="{name: 'admin-dashboard'}">
            <v-list-item-action>
              <v-icon>mdi-account</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t('layout.navDrawer.administration') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <template v-if="isModerator">
          <v-divider inset></v-divider>

          <v-list-item :to="{name: 'moderator-dashboard'}">
            <v-list-item-action>
              <v-icon>mdi-account</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t('layout.navDrawer.controller') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <template v-if="isMonitoring">
          <v-divider inset></v-divider>

          <v-list-item :to="{name: 'monitoring-dashboard'}">
            <v-list-item-action>
              <v-icon>mdi-account</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t('layout.navDrawer.monitoring') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <template v-if="isRevizor">
          <v-divider inset></v-divider>

          <v-list-item :to="{name: 'revizor-dashboard'}">
            <v-list-item-action>
              <v-icon>mdi-account</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t('layout.navDrawer.auditor') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>


    <v-main>
      <v-container fluid>
        <router-view v-if="$store.getters.appIsInitialized"/>
      </v-container>
    </v-main>

    <v-overlay :value="$store.getters.layoutIsLoading || !$store.getters.appIsInitialized">
      <v-progress-circular class="d-block" indeterminate size="64"></v-progress-circular>
      <v-btn style="margin: 10px 0 0 -30px" @click="onCancelClicked">{{ $t('layout.overlay.cancelBtn') }}</v-btn>
    </v-overlay>
  </v-app>
</template>

<script>
import {AUTH_LOGOUT} from "@/store/modules/auth/actions";
import {APP_INITIALIZE} from "@/store/modules/app/actions";
import {APP_INITIALIZE_FAILED} from "@/events/app";
import {Admin, Courier, Default, Moderator, Monitoring, Revizor} from "@/enums/user.type";
import AdminRegistyPermissionService from "@/services/admin.registy.permission.service";
import AdminTemplateService from "@/services/admin.template.service";
import AreaService from "@/services/area.service";
import AuthService from "@/services/auth.service";
import BalanceService from "@/services/balance.service";
import BranchService from "@/services/branch.service";
import ClientService from "@/services/client.service";
import GlobalOrganizationService from "@/services/global.organization.service";
import GlobalUnitService from "@/services/global.unit.service";
import GlobalUserService from "@/services/global.user.service";
import GlobalUserUnitPermissionService from "@/services/global.user.unit.permission.service.";
import MailCreateService from "@/services/mail.create.service";
import MailTrackingService from "@/services/mail.tracking.service";
import MailService from "@/services/mail.service";
import OrganizationService from "@/services/organization.service";
import RegionService from "@/services/region.service";
import RegistryService from "@/services/registry.service";
import StatisticsService from "@/services/statistics.service";
import TemplateService from "@/services/template.service";
import UnitService from "@/services/unit.service";
import UserService from "@/services/user.service";
import RegistryPermissionService from "@/services/registry.permission.service";
import contracttextService from "@/services/contracttext.service";
import {LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import LanguageSwitcher from "../components/locale/LanguageSwitcher.vue";

export default {
  name: "MainLayout",
  components: {
    LanguageSwitcher
  },
  data: () => ({
    drawer: null,
    left: false,
    contractText: "",
  }),
  methods: {
    updateContractText() {
      contracttextService.post({ text: this.contractText })
          .then(() => {
            console.success("Текст контракта обновлен"); // if you have a toast system
          })
          .catch(() => {
            console.error("Ошибка при обновлении контракта");
          });
    },
    onCancelClicked(){
      AdminRegistyPermissionService.cancelRequests();
      AdminTemplateService.cancelRequests();
      AreaService.cancelRequests();
      AuthService.cancelRequests();
      BalanceService.cancelRequests();
      BranchService.cancelRequests();
      ClientService.cancelRequests();
      GlobalOrganizationService.cancelRequests();
      GlobalUnitService.cancelRequests();
      GlobalUserService.cancelRequests();
      GlobalUserUnitPermissionService.cancelRequests();
      MailCreateService.cancelRequests();
      MailTrackingService.cancelRequests();
      MailService.cancelRequests();
      OrganizationService.cancelRequests();
      RegionService.cancelRequests();
      RegistryService.cancelRequests();
      StatisticsService.cancelRequests();
      TemplateService.cancelRequests();
      UnitService.cancelRequests();
      UserService.cancelRequests();
      RegistryPermissionService.cancelRequests()
    },
    onLogoutClicked() {
      this.$store.dispatch(AUTH_LOGOUT)
    },
    onLogout() {
      this.$router.push({name: 'login'})
    },
    onAppInitializationFailed() {
      this.$store.dispatch(AUTH_LOGOUT)
      this.$router.push({name: 'login'})
    },
    hasAccessToImportFromRegistry() {
      return this.$store.getters.hasAccessToImportFromRegistry
    },
  },
  computed: {
    isDefault() {
      return this.$store.getters.appIsInitialized && this.$store.getters.appLogin?.type === Default;
    },
    isAdmin() {
      return this.$store.getters.appIsInitialized && this.$store.getters.appLogin?.type === Admin;
    },
    isCourier() {
      return this.$store.getters.appIsInitialized && this.$store.getters.appLogin?.type === Courier;
    },
    isModerator() {
      return this.$store.getters.appIsInitialized && this.$store.getters.appLogin?.type === Moderator;
    },
    isMonitoring() {
      return this.$store.getters.appIsInitialized && this.$store.getters.appLogin?.type === Monitoring;
    },
    isRevizor() {
      return this.$store.getters.appIsInitialized && this.$store.getters.appLogin?.type === Revizor;
    },
    hasPermissionToSeeUnitStatistics() {
      if (this.isDefault) {
        if (this.$store.getters.appLogin?.unit?.isHead !== null) {
          return this.$store.getters.appLogin.unit.isHead;
        } else if (this.$store.getters.appLogin?.globalunit?.isHead !== null) {
          return this.$store.getters.appLogin.globalunit.isHead;
        }
      }
      return false;
    }
  },
  created() {
    console.log("Main layout created")
    contracttextService.get()
        .then(response => {
          this.contractText = response.data
        }, () => {
          this.loading = false
          this.$store.dispatch(LAYOUT_LOADING_STOP)
        });
    this.$store.dispatch(APP_INITIALIZE)

    this.$bus.$on(AUTH_LOGOUT, this.onLogout)
    this.$bus.$on(APP_INITIALIZE_FAILED, this.onAppInitializationFailed)
  },
  beforeDestroy() {
    this.$bus.$off(AUTH_LOGOUT, this.onLogout)
    this.$bus.$off(APP_INITIALIZE_FAILED, this.onAppInitializationFailed)
  }
}
</script>


<style scoped>
.contract-input .v-input__control input {
  color: black !important;
}

.contract-input .v-label {
  color: black !important;
}
</style>